import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter, FilterFrame, FilterSelection } from '../Filters.style';
import { FilterOption, FilterResultCounts, RangeResultsCounts } from '../../../types';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import FilterExposedHeader from '../FilterExposedHeader';
import { TrimLineListWrapper } from './TrimLineSelector.style';
import CheckboxSelector from '../../CheckboxComponent';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

interface TrimLineSelectorTypes {
  filterType: string;
  trimlineOptions: AvailableFiltersCount[];
  confirmedFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const TrimLineSelector: React.FC<TrimLineSelectorTypes> = ({
  filterType,
  trimlineOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const selectedTrimlines = confirmedFilters.trimLine;

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedTrimlines}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props} data-testid="trimline-filter-group">
              <FilterFrame style={filtersAccordianAnimation}>
                <TrimLineListWrapper>
                  {trimlineOptions.map((filterOption) => {
                    const { value, disabled } = filterOption;
                    return (
                      <CheckboxSelector
                        filterType={filterType}
                        inputName={`${filterType}-${value}`}
                        key={value}
                        onChange={() => handleAddFilter(filterType, value)}
                        value={value}
                        checked={selectedTrimlines.includes(value)}
                        disabled={disabled}
                      />
                    );
                  })}
                </TrimLineListWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default TrimLineSelector;
